<template>
  <div v-show="loading"> 
 	  <el-skeleton :rows="10" animated />
  </div>
  <!--begin::Tables Widget 11-->
  <div :class="widgetClasses" class="card" v-show="!loading">
    <!--begin::Header-->
    <div class="card-header border-0 pt-5">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label fw-bolder fs-3 mb-1">Rebates History</span>
      </h3>
    </div>
    <!--end::Header-->

    <!--begin::Body-->
    <div class="card-body py-3">
      <!--begin::Table container-->
      <div class="table-responsive">
        <!--begin::Table-->
        <table class="table align-middle gs-0 gy-4">
          <!--begin::Table head-->
          <thead>
            <tr class="fw-bolder text-muted bg-light">
              <th class="ps-4 min-w-125px rounded-start">Ref. #</th>
              <th class="min-w-225px">Product</th>
              <th class="min-w-225px">My Rebate</th>
              <th class="min-w-300px">Date</th>
            </tr>
          </thead>
          <!--end::Table head-->
          <!--begin::Table body-->
          <tbody>
            <template v-for="(item, index) in list" :key="index">
              <tr>
                <td>&nbsp;&nbsp;&nbsp;{{index + 1}}</td>
                <td>{{item.product}}</td>
                <td>{{numberWithCommas(item.myrebate)}}</td>
                <td>{{item.dtestp}}</td>
              </tr>
            </template> 
          </tbody>
          <!--end::Table body-->
        </table>
        <!--end::Table-->
      </div>
      <!--end::Table container-->
    </div>
    <!--begin::Body-->
  </div>
  <!--end::Tables Widget 11-->
</template>

<script lang="ts">
import { defineComponent } from "vue";
import {loadPaginatedRebates}  from "@/api/myrebates";

export default defineComponent({
  name: "kt-widget-11", 
  methods: {
    async loadPaginatedMyRebates(){ 
      this.loading = true;
      var param = {page : 1 };
        const response = await loadPaginatedRebates(param);
        this.list = response.data.pageList;
        this.loading = false;
      }
  },
  mounted(){
      this.loadPaginatedMyRebates();
  },
  data(){
      return { 
        list : [],
        loading: true,
      }
  },
  components: {},
  props: {
    widgetClasses: String
  }
});
</script>
